/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingEventLine
 */
export interface BillingEventLine {
    /**
     * 
     * @type {string}
     * @memberof BillingEventLine
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof BillingEventLine
     */
    estimatedCost: number;
}

/**
 * Check if a given object implements the BillingEventLine interface.
 */
export function instanceOfBillingEventLine(value: object): value is BillingEventLine {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('estimatedCost' in value) || value['estimatedCost'] === undefined) return false;
    return true;
}

export function BillingEventLineFromJSON(json: any): BillingEventLine {
    return BillingEventLineFromJSONTyped(json, false);
}

export function BillingEventLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingEventLine {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'estimatedCost': json['estimatedCost'],
    };
}

  export function BillingEventLineToJSON(json: any): BillingEventLine {
      return BillingEventLineToJSONTyped(json, false);
  }

  export function BillingEventLineToJSONTyped(value?: BillingEventLine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'estimatedCost': value['estimatedCost'],
    };
}

